export default "__VITE_ASSET__B8GCT0iZ__"